import { api } from "api";
import { useQuery } from "@tanstack/react-query";

/**
 * Client hook to query for the individual event history of a Patient/Responsible Party.
 * @param patientId The ID of the P/RP of the transaction.
 * @param transactionId The ID of the transaction to query for.
 * @returns React Query properties.
 */
export function useSingleTransactionHistory(patientId: number, transactionId: number) {
    const result = useQuery({
        queryKey: ["singleTransactionHistory", patientId, transactionId],
        queryFn: async (context) =>
            await api.patient.singleTransactionHistory(patientId, transactionId, context.signal),
        gcTime: 0, // if gcTime isn't 0, multiple quick partial refunds of one transaction will autofill input with wrong amount
    });

    return result;
}
